import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper";
import testimonialOneData from "./testimonialOneData";

const getInitials = (name) => {
    return name
        .split(' ')
        .slice(0, 2)
        .map((n) => n[0].toUpperCase())
        .join('');
};

const avatarColors = [
    '#7C4DFF', '#1976D2', '#388E3C', '#F57C00',
    '#C62828', '#00838F', '#AD1457', '#4527A0',
];

const TestimonialOne = () => {
    return (
        <section className="testimonial-carousel-wrapper section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 offset-lg-3 text-center col-12">
                        <div className="block-contents">
                            <div className="section-title">
                                <h2>What People say about us</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-12 col-12">
                        <div className="testimonial-carousel-active">
                            <Swiper
                                navigation={true}
                                modules={[Navigation]}
                                loop
                                slidesPerView={2}
                                spaceBetween={24}
                                breakpoints={{
                                    0: { slidesPerView: 1 },
                                    768: { slidesPerView: 2 },
                                }}
                            >
                                {testimonialOneData.map((data, index) => (
                                    <SwiperSlide key={data.id}>
                                        <div className="gr-card">
                                            <div className="gr-card-header">
                                                <div
                                                    className="gr-avatar"
                                                    style={{ backgroundColor: avatarColors[index % avatarColors.length] }}
                                                >
                                                    {getInitials(data.name)}
                                                </div>
                                                <div className="gr-meta">
                                                    <h5 className="gr-name">{data.name}</h5>
                                                    <span className="gr-time">{data.timeAgo}</span>
                                                </div>
                                            </div>
                                            <div className="gr-stars">
                                                {[...Array(5)].map((_, i) => (
                                                    <i key={i} className="fas fa-star"></i>
                                                ))}
                                            </div>
                                            <p className="gr-text">{data.speech}</p>
                                            {/* <div className="gr-footer">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="18" height="18">
                                                    <path fill="#4285F4" d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z"/>
                                                    <path fill="#34A853" d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.32-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z"/>
                                                    <path fill="#FBBC05" d="M11.68 28.18A13.87 13.87 0 0 1 10.8 24c0-1.45.25-2.86.88-4.18v-5.7H4.34A23.93 23.93 0 0 0 0 24c0 3.87.93 7.53 2.56 10.77l7.12-5.52-.01-1.07z"/>
                                                    <path fill="#EA4335" d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 13.12l7.34 5.7C13.42 14.62 18.27 10.75 24 10.75z"/>
                                                </svg>
                                                <span>Posted on Google</span>
                                            </div> */}
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TestimonialOne;
